import {Cached} from './Cached';
import {asString} from '../../helpers/converters/asString';

export function Once(): MethodDecorator {
    return Cached((prop) => Symbol.for(`@Once(${asString(prop)}).ONCE`));
}
